module.exports = __webpack_public_path__ + "static/media/security-industry.2b5f8bb1.png";